import * as React from "react";
import { cn } from "../../lib/utils";
import "./anti-metal-button.css";

const DoubleChevron = ({ index, dotColor }) => {
  const base = index * 0.12;
  const dots = [
    { cx: 2, cy: 2, d: 0 },
    { cx: 5, cy: 5, d: 0.05 },
    { cx: 8, cy: 8, d: 0.1 },
    { cx: 5, cy: 11, d: 0.15 },
    { cx: 2, cy: 14, d: 0.2 },
    { cx: 6, cy: 2, d: 0.05 },
    { cx: 9, cy: 5, d: 0.1 },
    { cx: 12, cy: 8, d: 0.15 },
    { cx: 9, cy: 11, d: 0.2 },
    { cx: 6, cy: 14, d: 0.25 },
  ];

  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      aria-hidden="true"
      focusable="false"
      className="shrink-0 overflow-visible"
      style={{ flexShrink: 0 }}
    >
      <g fill={dotColor}>
        {dots.map((p, i) => (
          <circle
            key={i}
            cx={p.cx}
            cy={p.cy}
            r="1"
            className="amb-dot"
            style={{ animationDelay: `${base + p.d}s` }}
          />
        ))}
      </g>
    </svg>
  );
};

export const AntiMetalButton = React.forwardRef(
  (
    {
      className,
      children,
      label,
      as: Component = "button",
      accentFrom = "#ec2b28",
      accentTo = "#c41e1b",
      dotColor = "#ffffff",
      style,
      ...props
    },
    ref
  ) => {
    const content = label ?? children ?? "Book a demo";
    return (
      <Component
        ref={ref}
        className={cn("amb-btn", className)}
        style={style}
        {...props}
      >
        <span
          aria-hidden="true"
          className="amb-pill"
          style={{
            background: `linear-gradient(180deg, ${accentFrom} 0%, ${accentTo} 100%)`,
          }}
        >
          <DoubleChevron index={0} dotColor={dotColor} />
          <DoubleChevron index={1} dotColor={dotColor} />
          <DoubleChevron index={2} dotColor={dotColor} />
          <DoubleChevron index={3} dotColor={dotColor} />
          <DoubleChevron index={4} dotColor={dotColor} />
          <DoubleChevron index={5} dotColor={dotColor} />
          <DoubleChevron index={6} dotColor={dotColor} />
          <DoubleChevron index={7} dotColor={dotColor} />
          <DoubleChevron index={8} dotColor={dotColor} />
          <DoubleChevron index={9} dotColor={dotColor} />
          <DoubleChevron index={10} dotColor={dotColor} />
          <DoubleChevron index={11} dotColor={dotColor} />
        </span>
        <span className="amb-text">
          {content}
        </span>
      </Component>
    );
  }
);

AntiMetalButton.displayName = "AntiMetalButton";

export default AntiMetalButton;
